import { Heading } from "@trueskin-web/components"

import Accordion from "../../components/choose-plan/components/accordion"

const FAQs = ({ title, items, children }) =>
  !!items?.length ? (
    <>
      {!!title && (
        <Heading
          as="h3"
          mt={6}
          mb={4}
          sx={{
            lineHeight: "body",
          }}
        >
          {title}
        </Heading>
      )}
      {children}
      {items.map(({ icon, question, answer }, index) => (
        <Accordion key={index} icon={icon} title={question}>
          {answer}
        </Accordion>
      ))}
    </>
  ) : null

export default FAQs
